import uuid from 'uuid/v4';
import {
    BRAND_LIBRARY_DARK_TEXT_COLOR,
    BRAND_LIBRARY_LIGHT_TEXT_COLOR,
    BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
    BRAND_LIBRARY_BUTTON_HOVER_COLOR,
    BRAND_LIBRARY_BODY_TEXT,
    BRAND_LIBRARY_HEADLINE_TEXT,
    BRAND_LIBRARY_SUBHEADLINE_TEXT,
    BRAND_LIBRARY_BUTTON_TEXT,
} from 'common/constants/brandLibrary';

const rootUuid = uuid();
const modalUuid = uuid();
const logoUuid = uuid();
const confirmationHeadlineUuid = uuid();
const confirmationMessageUuid = uuid();
const buttonUuid = uuid();
const addToCalendarUuid = uuid();

export const rsvpWaitlist = {
    [rootUuid]: {
        id: rootUuid,
        type: 'Fragment',
        root: true,
        props: {
            styles: {},
            meta: {},
        },
        childNodes: [modalUuid],
    },
    [modalUuid]: {
        id: modalUuid,
        type: 'Modal',
        props: {
            styles: {},
            meta: {
                displayName: 'Modal',
            },
            descendants: {
                modalContent: {
                    styles: {
                        backgroundColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
                        padding: {
                            top: 64,
                            bottom: null,
                            left: 48,
                            right: null,
                        },
                        gap: 32,
                        alignment: {
                            mainDirection: 'start',
                            perpendicularDirection: 'start',
                        },
                        direction: 'column',
                    },
                },
                closeButton: {
                    styles: {
                        color: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                        colorHover: BRAND_LIBRARY_BUTTON_HOVER_COLOR,
                    },
                },
            },
        },
        childNodes: [logoUuid, confirmationHeadlineUuid, confirmationMessageUuid, addToCalendarUuid, buttonUuid],
    },
    [logoUuid]: {
        id: logoUuid,
        type: 'Logo',
        props: {
            meta: {
                visible: true,
                displayName: 'Logo',
            },
            styles: {},
            childNodes: [],
        },
    },
    [confirmationHeadlineUuid]: {
        id: confirmationHeadlineUuid,
        type: 'Headline',
        props: {
            styles: {
                fontSize: 24,
                fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
                fontFamily: BRAND_LIBRARY_HEADLINE_TEXT,
            },
            meta: {
                displayName: 'Confirmation Headline',
                content: '[confirmation_headline]',
                visible: true,
            },
        },
        childNodes: [],
    },
    [confirmationMessageUuid]: {
        id: confirmationMessageUuid,
        type: 'TextParagraph',
        props: {
            styles: {
                fontSize: 14,
                fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
                fontFamily: BRAND_LIBRARY_BODY_TEXT,
            },
            meta: {
                content: '[confirmation_messaging]',
                displayName: 'Confirmation Message',
                visible: true,
            },
        },
        childNodes: [],
    },
    [buttonUuid]: {
        id: buttonUuid,
        type: 'Button',
        props: {
            styles: {
                backgroundColor: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                backgroundColorHover: BRAND_LIBRARY_BUTTON_HOVER_COLOR,
                fontColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
                fontColorHover: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
                fontSize: 14,
                fontFamily: BRAND_LIBRARY_BUTTON_TEXT,
                borderColor: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                borderColorHover: BRAND_LIBRARY_BUTTON_HOVER_COLOR,
                borderWidth: {
                    top: 1,
                    bottom: 1,
                    left: 1,
                    right: 1,
                },
                borderRadius: 4,
            },
            meta: {
                content: 'Button Label',
                href: '',
                displayName: 'Custom Button',
                visible: true,
            },
        },
        childNodes: [],
    },
    [addToCalendarUuid]: {
        id: addToCalendarUuid,
        type: 'CalendarAttachment',
        props: {
            styles: {},
            meta: {
                displayName: 'Calendar Attachment',
                visible: true,
            },
            descendants: {
                headline: {
                    styles: {
                        fontSize: 14,
                        fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
                        fontFamily: BRAND_LIBRARY_SUBHEADLINE_TEXT,
                    },
                    meta: {
                        content: 'Add to Calendar',
                    },
                },
                providerLogoIcons: {
                    styles: {
                        color: null,
                        colorHover: null,
                    },
                },
                providerLogoNames: {
                    styles: {
                        fontSize: 14,
                        fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
                        fontFamily: BRAND_LIBRARY_BODY_TEXT,
                    },
                },
            },
        },
        childNodes: [],
    },
};
